module.exports = __webpack_public_path__ + "static/media/logo-beta.4b8d1642.svg";